class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      const productSectionHtml = parsedState.sections?.['cart-notification-product'];
      const productSectionDocument = productSectionHtml
        ? new DOMParser().parseFromString(productSectionHtml, 'text/html')
        : null;
      const giftStateMarker = productSectionDocument?.querySelector('[data-cart-has-gift-subscription]');
      const hasGiftSubscription = giftStateMarker?.dataset.cartHasGiftSubscription === 'true';

      this.getSectionsToRender().forEach((section => {
        const sectionHtml = parsedState.sections?.[section.id];
        if (!sectionHtml) return;

        const sectionElement = document.getElementById(section.id);
        if (!sectionElement) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      }));

      const checkoutForm = this.querySelector('#cart-notification-form');
      if (checkoutForm) {
        checkoutForm.hidden = hasGiftSubscription;
        checkoutForm.setAttribute('aria-hidden', String(hasGiftSubscription));

        const checkoutButton = checkoutForm.querySelector('[name="checkout"]');
        if (checkoutButton) {
          checkoutButton.disabled = hasGiftSubscription;
          checkoutButton.setAttribute('aria-disabled', String(hasGiftSubscription));
        }
      }

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
